<template lang="pug">
.__form-checkbox(:class="{ error: vError }")
  input(
    type="hidden"
    :name="name"
    :value="htmlValue"
  )
  label.__form-checkbox__label(
    :class="labelClasses"
    @click="change(!value); $emit('click')"
  )
    slot
    span.__form-checkbox__special(v-if="$slots.special")
      slot(name="special")
</template>

<script>
export default {
  props: ['name', 'value', 'disabled', 'error', 'v'],

  computed: {
    vError() {
      return this.error || (this.v && this.v.$error);
    },

    htmlValue() {
      const { value } = this;
      return value === undefined ? 0 : Number(value);
    },

    labelClasses() {
      return {
        '__form-checkbox__label_special': this.$slots.special,
        checked: this.value,
        disabled: this.disabled,
      };
    },
  },

  methods: {
    change(value) {
      if (!this.disabled) {
        if (this.v) {
          this.v.$touch();
        }
        this.$emit('input', value);
      }
    },

    blur($event) {
      if (this.v) {
        this.v.$touch();
      }
      this.$emit('blur', $event);
    },
  },
};
</script>

<style lang="scss" scoped>
.__form-checkbox {
  position: relative;

  &.error {
    color: red;

    .__form-checkbox__label::before {
      border-color: red;
    }
  }

  .__form-checkbox__label {
    padding-left: 26px;
    padding-top: 0.27em;
    font-size: 14px;
    cursor: pointer;
    position: relative;

    &::before {
      border-color: #ccc;
      background-color: #fff;
      left: 0;
      top: 0.27em;
      width: 1.15em;
      height: 1.15em;
      border-width: 0.071em;
      content: '';
      position: absolute;
      left: 0;
      border-style: solid;
      box-shadow: inset 2px 2px 8px rgba(0, 0, 0, 0.1);
    }

    &::after {
      font-size: 0.9em;
      width: 1.2em;
      height: 0.6em;
      border-width: 0 0 0.143em 0.143em;
      top: 0.35em;
      left: 0.2em;
      transform: rotate(-45deg);
      opacity: 0;
      content: '';
      position: absolute;
      border-style: solid;
      transition: all 0.1s ease-in;
      border-left: 3px solid #23bb67;
      border-bottom: 3px solid #23bb67;
    }

    &_special {
      display: block;
    }

    &.checked {
      &::after {
        opacity: 1;
      }
    }

    &.disabled {
      &::before {
        opacity: 0.7;
      }

      &.checked {
        &::after {
          opacity: 0.7;
        }
      }
    }
  }

  &__special {
    font-size: 13px;
    line-height: 1.25;
    display: inline-block;
    @media screen and (max-width: 48em) {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Checkbox.vue?69864804